export default "__VITE_ASSET__920b1e2d__"